const productList = [
    {
        no: 0,
        title: '기타',
        products: [
            {
                no: 0,
                title: '기타 문의 사항'
            }
        ]
    },
    {
        no: 1,
        title: '엔드포인트 보안',
        products: [
            {
                no: 0,
                title: 'TACHYON Endpoint Security 5.0'
            },
            {
                no: 1,
                title: 'TACHYON Endpoint Security 5.5'
            },
            {
                no: 2,
                title: 'TACHYON Server Security 5.0'
            },
            {
                no: 3,
                title: 'TACHYON White Security 5.0'
            },
            {
                no: 4,
                title: 'TACHYON Linux Security 5.0'
            }
        ]
    },
    {
        no: 2,
        title: '중앙 관리 엔드포인트 보안',
        products: [
            {
                no: 0,
                title: 'TACHYON UMS 4.0'
            },
            {
                no: 1,
                title: 'TACHYON Total Security 3.5'
            },
            {
                no: 2,
                title: 'TACHYON Patch Manager System 3.0'
            },
            {
                no: 3,
                title: 'TACHYON Relay Server 3.0'
            }
        ]
    },
    {
        no: 3,
        title: '보안 유틸리티',
        products: [
            {
                no: 0,
                title: 'TACHYON File Wiper 1.0'
            },
            {
                no: 1,
                title: 'TACHYON Disk Wiper 1.0'
            },
            {
                no: 2,
                title: 'TACHYON File Crptor 1.0'
            }
        ]
    },
    {
        no: 4,
        title: '유틸리티',
        products: [
            {
                no: 0,
                title: 'TACHYON Hash Viewer 1.0'
            }
        ]
    },
    {
        no: 5,
        title: '보안 SDK',
        products: [
            {
                no: 0,
                title: 'TACHYON Core Suite 1.0'
            }
        ]
    }
]

const MailProductSelectList = class MailProductSelectList {
    constructor() {
        productList.forEach((value)=> {
            this.list.push(value);
        })
    }

    list = [];

    get items() {
        return this.list;
    }

}

export default MailProductSelectList;